/* eslint-disable */
import './LandingSellContent.css';

import PropTypes from 'prop-types';
import ICON_ARROW_RIGHT from '../../assets/images/icon_arrow_right_white.svg';
import ICON_SELL_DELIVERY from '../../assets/images/icon_sell_delivery.svg';
import ICON_SELL_LISTING from '../../assets/images/icon_sell_listing.svg';
import ICON_SELL_REGISTER from '../../assets/images/icon_sell_register.svg';
import ICON_SELL_TAKE_ORDER from '../../assets/images/icon_sell_take_order.svg';

const LandingSellContent = (props) => {
  const renderProcessStep = (title, description, icon, link) => {
    const content = (
      <>
        <div className='step-icon-wrapper'>
          <img src={icon} alt={title} className='process-step-icon' />
        </div>
        <b className='step-title'>{title}</b>
        <div className='step-description'>{description}</div>
      </>
    );

    if (link) {
      return (
        <a href={link} target='_blank' rel='noopener noreferrer' className='process-step-card'>
          {content}
        </a>
      );
    }

    return <div className='process-step-card'>{content}</div>;
  };

  const renderSellSection = () => {
    return (
      <div className='sell-section'>
        <b className='sell-section-title'>การขายสินค้ากับมียา.com</b>
        <div className='sell-section-description'>
          <p className='sell-section-paragraph'>&quot;เราสร้างแพลตฟอร์มที่ปลอดภัยและใช้งานง่าย</p>
          <p className='sell-section-paragraph'>{`เพื่อช่วยผู้ประกอบการลดต้นทุน แก้ปัญหายาหมดอายุ `}</p>
          <p className='sell-section-paragraph'>และเพิ่มศักยภาพร้านค้า ด้วยฐานข้อมูลรายการสินค้า</p>
          <p className='sell-section-paragraph'>สำเร็จรูป กำหนดราคาขายได้อิสระ พร้อมการสนับสนุน</p>
          <p className='sell-section-paragraph'>ที่จะช่วยให้ธุรกิจดำเนินไปอย่างราบรื่น&quot;</p>
        </div>
        <button
          onClick={() => {
            if (props.callback_popup_signin) {
              props.callback_popup_signin();
            }
          }}
          className='start-selling-button'
        >
          <div className='button-content'>
            <div className='button-text'>เริ่มขายสินค้า</div>
            <img className='arrow-icon' alt='' src={ICON_ARROW_RIGHT} />
          </div>
        </button>
      </div>
    );
  };

  const renderSellProcessSection = () => {
    return (
      <div className='sell-process-section'>
        <div className='process-steps'>
          {renderProcessStep(
            'REGISTER',
            'ลงทะเบียนร้านค้าของคุณ',
            ICON_SELL_REGISTER,
            'https://www.youtube.com/watch?v=kegDStMlbSU&index=1&t=14s',
          )}
          {renderProcessStep(
            'LISTING',
            'ลงขายสินค้าในร้านค้าของคุณ',
            ICON_SELL_LISTING,
            'https://www.youtube.com/watch?v=RRe_GeTFr9k&index=5&t=27s',
          )}
          {renderProcessStep(
            'TAKE ORDER',
            'รับคำสั่งซื้อ',
            ICON_SELL_TAKE_ORDER,
            'https://www.youtube.com/watch?v=CsLNpDvaD6c&index=2&t=12s',
          )}
          {renderProcessStep(
            'DELIVERY',
            'เตรียมสินค้าสำหรับจัดส่ง และรอรถไปรับ',
            ICON_SELL_DELIVERY,
            'https://www.youtube.com/watch?v=CsLNpDvaD6c&index=2&t=40s',
          )}
        </div>
      </div>
    );
  };

  return (
    <div id='landing-sell-section' className='landing-sell-container'>
      <div className='landing-sell-inner-container'>
        <div className='landing-sell-row'>
          {renderSellSection()}
          {renderSellProcessSection()}
        </div>
      </div>
    </div>
  );
};

LandingSellContent.propTypes = {
  callback_popup_signin: PropTypes.func,
};

export default LandingSellContent;
